import { inject, Injectable, signal } from '@angular/core';

import { AudioUnlockService } from './audio-unlock.service';

@Injectable({ providedIn: 'root' })
export class SoundService {
  private readonly audioUnlockService = inject(AudioUnlockService);
  private readonly pendingSounds = signal<string[]>([]);

  playSound(url: string) {
    if (!this.audioUnlockService.isUnlocked()) {
      this.pendingSounds.set([...this.pendingSounds(), url]);
      return;
    }
    this.playNow(url);
  }

  notifyUnlocked() {
    if (this.pendingSounds().length) {
      this.pendingSounds().forEach((url) => this.playNow(url));
      this.pendingSounds.set([]);
    }
  }

  private playNow(url: string) {
    const audio = new Audio(url);
    audio.play();
  }
}
